import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  Space,
  Form,
  Button,
  notification,
  message,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import userRequest from "../UserRequest";
import roleRequest from "../RoleRequest";
import { Option } from "antd/es/mentions";

export const AddUser = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [roleList, setRoleList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [showVendorDropdown, setShowVendorDropdown] = useState(false); // State to control the visibility of the Vendor dropdown

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    const allFormData = { ...values };
    console.log(allFormData);
    userRequest
      .createUser(allFormData)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          notification.success({
            message: "User added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add user",
        });
        console.error("API Error:", e);
      });
  };

  const handleChange = (value, name) => {
    console.log(`selected ${value}`);
    if (name === "roleId") {
      setShowVendorDropdown(value === 3); // Show Vendor dropdown only if roleId is 2
    }

    // Concatenate firstName and lastName for fullName
    if (name === "firstName" || name === "lastName") {
      const firstName = form.getFieldValue("firstName");
      const lastName = form.getFieldValue("lastName");
      form.setFieldsValue({
        fullName: `${firstName} ${lastName}`,
      });
    }
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  const fetchRoleList = () => {
    setLoading(true);
    roleRequest
      .roleList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData);
        setRoleList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch role list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchVendorList = () => {
    setLoading(true);
    userRequest
      .vendorList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData);
        setVendorList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch vendor list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchVendorList();
    fetchRoleList(); // Fetch the role list when the component mounts
  }, []);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add User</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div className="subscription">
              <Form.Item
                name="firstName"
                label="First Name"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the first name!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message:
                      "First name can only contain alphabetic characters!",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter First Name"
                  onChange={(e) => handleChange(e.target.value, "firstName")}
                />
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Last Name"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the last name!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message:
                      "Last name can only contain alphabetic characters!",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter Last Name"
                  onChange={(e) => handleChange(e.target.value, "lastName")}
                />
              </Form.Item>

              <Form.Item
                name="fullName"
                label="Full Name"
                className="subscription-plan"
              >
                <Input size="large" disabled />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="email"
                label="Email"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input size="large" placeholder="Enter User Email" />
              </Form.Item>
              <Form.Item
                name="mobile"
                label="Phone No"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Phone No!",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Phone No must be exactly 10 digits!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Phone No" />
              </Form.Item>

              {/* <Form.Item
                name="walletAmt"
                label="Wallet Amount"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Wallet Amount",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Wallet Amount"
                />
              </Form.Item> */}
            </div>

            <div className="subscription">
              <Form.Item
                name="userName"
                label="User Name"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the user name!" },
                ]}
              >
                <Input size="large" placeholder="Enter User Name" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the password!" },
                  {
                    type: "password",
                    message: "Please enter a valid password!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter password" />
              </Form.Item>
              {/* <Form.Item
                name="roleId"
                label="Role"
                className="subscription-plan"
                rules={[{ required: true, message: "Please select the role!" }]}
              >
                <Select
                  placeholder="Select The role"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "roleId")}
                >
                  {roleList?.length > 0 &&
                    roleList.map((item, idx) => (
                      <Option
                        key={idx}
                        className="text-capitalize"
                        value={item?.id}
                      >
                        {item?.roleName}
                      </Option>
                    ))}
                </Select>
              </Form.Item> */}

              {/* Show Vendor Dropdown only if roleId is 2 */}
              {/* {showVendorDropdown && (
                <Form.Item
                  name="ownerId"
                  label="Vendor"
                  className="subscription-plan"
                  rules={[
                    { required: true, message: "Please select the Vendor!" },
                  ]}
                >
                  <Select
                    placeholder="Select The Vendor"
                    style={{ marginTop: "0.5rem", width: "99%" }}
                    onChange={handleChange}
                  >
                    {vendorList?.length > 0 &&
                      vendorList.map((item, idx) => (
                        <Option
                          key={idx}
                          className="text-capitalize"
                          value={item?.id}
                        >
                          {item?.fullName}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              )} */}
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
